import { render, staticRenderFns } from "./FinanceWeeksSummary.vue?vue&type=template&id=27dd5e22&"
import script from "./FinanceWeeksSummary.vue?vue&type=script&lang=js&"
export * from "./FinanceWeeksSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports